import React from 'react';
import PropTypes from 'prop-types';
const loaderImgUrl = new URL('./loader-square-red.gif', import.meta.url).href;

function MLLoading(props) {
  return (
    <img
      className={props.className || ''}
      src={loaderImgUrl}
      role="presentation"
      alt="loader"
    />
  );
}

MLLoading.propTypes = {
  className: PropTypes.string,
};

export default MLLoading;
